import { render, staticRenderFns } from "./VideoIframe.vue?vue&type=template&id=6f9c76fb"
import script from "./VideoIframe.vue?vue&type=script&lang=js"
export * from "./VideoIframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports